import React from 'react';
import {Link} from "react-router-dom";
import {Slang} from "../../../helpers";

const InvestorsMenu = () => {
    const menu1 = Slang('dashboard.menu.m1');
    return (
        <div id="dashboardSidebar" className="nav-collapse collapse ">
            <a className="nav-link dropdown-toggle"
               href="#investorMenu" role="button"
               data-bs-toggle="collapse"
               aria-expanded="false"
               aria-controls="investorMenu">{menu1('m12.title')}</a>

            <div id="investorMenu" className="nav-collapse collapse ">
                <Link className="nav-link" to="/dashboard/company">{menu1('m12.u3.m131')}</Link>
                <Link className="nav-link" to="/dashboard/company">{menu1('m12.u3.m132')}</Link>
            </div>
        </div>
    );
};

export default InvestorsMenu;